/**
 * performance-design-web-oberflaeche: Query-Key-Fabrik. `staleTime` je
 * Ressourcenklasse ist in `queryClient.ts`/den jeweiligen Hooks festgelegt,
 * nicht hier -- diese Datei liefert ausschliesslich die Schlüssel-Tupel.
 */
export interface ModelFilter {
  readonly provider?: string;
  readonly status?: string;
  readonly q?: string;
  readonly page?: number;
}

export interface SourceTreeFilter {
  readonly q?: string;
  readonly status?: string;
  readonly art?: string;
}

export const queryKeys = {
  dashboard: () => ['dashboard'] as const,
  notes: (sort: 'recent' | 'priority') => ['notes', sort] as const,
  sources: (filter: SourceTreeFilter) => ['sources', filter] as const,
  source: (id: string) => ['sources', id] as const,
  models: (filter: ModelFilter) => ['models', filter] as const,
  reviewContext: (modelId: string) => ['models', modelId, 'review-context'] as const,
  change: (id: string) => ['changes', id] as const,
  matrix: () => ['matrix'] as const,
  matrixTransfers: () => ['matrix', 'transfers'] as const,
  templateRender: (templateId: string, context: string | undefined, full: boolean) =>
    ['templates', templateId, 'render', context, full] as const,
  settings: () => ['settings'] as const,
  me: () => ['me'] as const,
};
